
 const ActionTypes = {
    ADD_USER : 1,
    DELETE_USER : 2,
    ADD_COMPANYLOCATIONS : 3,
    ADD_DEPARTMENT : 4,
    ADD_EMPLOYEE : 5,
    ADD_EMPLOYEE_SETTINGS : 6,
    ADD_POSITIONS : 7,
    ADD_PROJECTS : 8,
    ADD_JOBS : 9,
    ADD_BACKUP : 10,
    ADD_COMPANY_VERSION : 11,
    DELETE_COMPANY_VERSION : 12,
    SEND_COMMAND : 13,
    DELETE_COMMAND_PENDING : 14,
    ADD_VERSION : 15,
    DELETE_VERSION : 16,
    ADD_APK : 17,
    DELETE_APK : 18,
    UPDATE_APK : 19,
    SAVE_RESTORE_BACKUP : 20,
    CLEAN_CACHE_DEVICE : 21,
    CLEAN_RESTRICTION : 22,
    DELETE_LOCATIONS : 23,
    DELETE_DEPARTMENTS : 24,
    DELETE_EMPLOYEES : 25,
    DELETE_POSITIONS : 26,
    DELETE_PROJECTS : 27,
    DELETE_JOBS : 28,
    DELETE_DUPLICATED_PUNCH : 29,
    DELETE_FINGER_PRINT : 30,
    ADD_USER_TIMELOGS : 31,
    DELETE_USER_TIMELOGS : 32,
    UPDATE_VIVENTIUM_API_SETTING : 33,
    UPDATE_GEOTAB_API_SETTING : 34,
    UPDATE_EASYSCHEDULING_API_SETTING : 35,
    ADD_API_SETTING : 36,
    DELETE_API_SETTING : 37,
    UPDATE_JAMIS_API_SETTING : 38,
    UPDATE_QUICKPAY_API_SETTING : 39,
    UPDATE_ONSHIFT_API_SETTING : 40,
    UPDATE_REPORT_EMAIL_API_SETTING : 41,
    UPDATE_ARBOR_API_SETTING : 42,
    UPDATE_ADRENALIN_API_SETTING : 43,
    UPDATE_XERO_API_SETTING : 44,
    UPDATE_EXPORT_TO_FTP_API_SETTING : 45,
    UPDATE_DISCONNECTED_DEVICE_API_SETTING : 46,
    CLEAN_DEVICE_RESTRICTION : 47,
}
export default ActionTypes;


// WEBPACK FOOTER //
// ./src/utils/actions.js